import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getAllPlans, getMyPlans } from './thunks';
import { PlansState } from './types';

export const name = 'Plans';

const initialState: PlansState = {
  data: [],
  details: null,
  status: 'idle',
  updatingStatus: 'idle',
  myPlans: [],
  myPlansStatus: 'idle',
};

export const getAllPlansAsync = createAsyncThunk(
  name + '/getAllPlans',
  getAllPlans
);

export const getMyPlansAsync = createAsyncThunk(
  name + '/getMyPlans',
  getMyPlans
);

export const slice = createSlice({
  name: name,
  initialState,
  reducers: {
    clear: () => {
      return initialState;
    },
    clearDetails: (state) => {
      state.details = null;
    },
    setMyPlans: (state, action) => {
      state.myPlans = action.payload;
    },
    removeMyPlans: (state) => {
      state.myPlans = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllPlansAsync.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(getAllPlansAsync.fulfilled, (state, action) => {
        state.status = 'idle';
        state.data = action.payload;
      })
      .addCase(getAllPlansAsync.rejected, (state, action) => {
        state.status = 'failed';
      })
      .addCase(getMyPlansAsync.pending, (state) => {
        state.myPlansStatus = 'loading';
      })
      .addCase(getMyPlansAsync.fulfilled, (state, action) => {
        state.myPlansStatus = 'idle';
        state.myPlans = action.payload;
      })
      .addCase(getMyPlansAsync.rejected, (state, action) => {
        state.myPlansStatus = 'failed';
      });
  },
});

export const actions = slice.actions;

export default slice.reducer;
